module.exports = __webpack_public_path__ + "img/GHS02.b1e9615f.webp";